module.exports = "https://cdn.realtymogul.com/static/media/chair_hero.1078499f.jpg";